var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page",class:{'p-2 md:px-6 md:py-8' : _vm.$route.meta.padding}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }